<template>
  <div v-if="selectedAssetVisit?.id">
    <v-card elevation="0">
      <v-card-title class="d-flex flex-row card-header">
        <p data-testid="yard-asset-visit-detail-title">
          {{ t('yard.messages.notAssigned') }}
        </p>
        <v-spacer></v-spacer>
        <v-btn
          icon="mdi-close"
          variant="text"
          density="comfortable"
          @click="closeDetail"
          data-testid="yard-asset-visit-close-button"></v-btn>
      </v-card-title>
      <v-card-text data-testid="yard-asset-visit-detail-content" class="card-content-no-actions">
        <yard-view-asset-visit-detail-data
          v-if="!isAssetContainer(selectedAssetVisit)"
          @assign="handleAssignSpotSelection"
          :asset-visit="selectedAssetVisit" />
        <yard-view-asset-container-detail-data
          v-else
          @assign="handleAssignSpotSelection"
          :asset-container="selectedAssetVisit" />
      </v-card-text>
      <v-card-actions class="card-actions" data-testid="yard-asset-visit-detail-actions">
        <div class="d-flex flex-column full-width">
          <v-btn
            variant="outlined"
            block
            class="mb-2"
            @click="isDepartAssetVisitDialogVisible = true">
            <v-icon size="small" class="mr-1">mdi-truck-fast-outline</v-icon>
            {{ t('assetVisit.common.terms.departed') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <yard-view-asset-visit-depart-dialog
      :asset-visit="selectedAssetVisit"
      :is-visible="isDepartAssetVisitDialogVisible"
      @close="isDepartAssetVisitDialogVisible = false" />
  </div>
</template>
<script>
import { computed, defineComponent, ref } from 'vue';
import { useEventHub } from '@/composables';

import useYard from '@/modules/yard/composables/useYard';
import YardViewAssetVisitDetailData from '@/modules/yard/components/AssetVisit/Detail/YardViewAssetVisitDetailData.vue';
import YardViewAssetContainerDetailData from '@/modules/yard/components/AssetContainer/YardViewAssetContainerDetailData.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewAssetVisitDetail',
  components: { YardViewAssetVisitDetailData, YardViewAssetContainerDetailData },
  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const eventHub = useEventHub();

    const isDepartAssetVisitDialogVisible = ref(false);

    const closeDetail = () => {
      yardStore.selectedAssetVisitRef.value = null;
    };

    const handleAssignSpotSelection = async spotId => {
      const spot = yardStore.spotsRef.value.find(spot => spot.id === spotId);

      if (spot?.id) {
        const isAssetContainer = yardStore.isAssetContainer(yardStore.selectedAssetVisitRef.value);

        if (yardStore.isSpotOpen(spot)) {
          await yardStore.createSpotAssignment({
            [yardStore.isAssetContainer(yardStore.selectedAssetVisitRef.value)
              ? 'assetContainerId'
              : 'assetVisitId']: yardStore.selectedAssetVisitRef.value.id,
            spotId: spot.id
          });
        } else {
          // If the spot is not open, we need to update the existing spot assignment
          // if this selectedAsset is an assetContainer update the assetContaineId
          // if this selectedAsset is an assetVisit update the assetVisitId
          await yardStore.updateSpotAssignment(spot.spotAssignments[0]?.id, {
            spotId: spot.id,
            [isAssetContainer ? 'assetContainerId' : 'assetVisitId']:
              yardStore.selectedAssetVisitRef.value.id
          });
        }

        eventHub.$emit(yardStore.SPOT_ASSIGNMENT_CHANGED, {
          assetVisit: yardStore.selectedAssetVisitRef.value,
          newSpotCode: spot.code,
          newSpotAreaName: yardStore.spotAreasRef.value.find(area => area.id === spot.spotAreaId)
            ?.name
        });

        yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.ASSIGNED, {
          spot,
          assetVisit: yardStore.selectedAssetVisitRef.value,
          entryPoint: 'Select from List'
        });

        yardStore.selectedAssetVisitRef.value = null;
        yardStore.selectedSpotRef.value = spot;
      }
    };

    const appointment = computed(() => {
      return yardStore.selectedAssetVisitRef?.value?.appointment;
    });

    return {
      t,
      isDepartAssetVisitDialogVisible,
      closeDetail,
      appointment,
      handleAssignSpotSelection,
      isAssetContainer: yardStore.isAssetContainer,
      selectedWarehouse: yardStore.selectedWarehouseRef,
      selectedAssetVisit: yardStore.selectedAssetVisitRef
    };
  }
});
</script>
